export default {
  en: {
    message: {
      hello: 'hello world',
      instruction: 'instruction',
      practiceAborted: 'Practice aborted',
      completed: 'Completed'
    }
  },
  no: {
    message: {
      hello: 'hei verden',
      instruction: 'Instruksjon',
      practiceAborted: 'Trening avbrutt',
      completed: 'Fullført',
      // Test names
      dsf: 'Tallspenn framlengs',
      dsb: 'Tallspenn baklengs',
      cod: 'Symbol-tall utfordring',
      vm: 'Ord-hukommelse',
      vismem: 'Hvor var hva?',
      srt: 'Enkel reaksjonstid',
      crt: 'Reaksjonstid med en vri',
      mst: 'Bildehukommelse'
    }
  }
}



// WEBPACK FOOTER //
// ./src/data/translations.js